import * as React from 'react';
import { AuthenticatorState } from '../components';

export function Account({ user }: AuthenticatorState) {
  // to get token you can use console.log(user.signInUserSession.idToken);
  return <p>Welcome you are logged in! {user.username}</p>;
}
